import React from 'react';
import { motion } from 'framer-motion';

const STEPS = [
  { n: '01', title: 'Discover', desc: 'We dig into your goals, users and constraints — no fluff.', cadence: 'Kickoff call + shared brief within 48h' },
  { n: '02', title: 'Design', desc: 'Motion prototypes and hi-fi designs you can feel before we build.', cadence: 'Weekly design reviews' },
  { n: '03', title: 'Build', desc: 'Clean, performant engineering with progress you can watch live.', cadence: 'Daily Slack access + weekly demos' },
  { n: '04', title: 'Launch & Support', desc: 'We ship, measure, and stay on to help you grow.', cadence: 'Post-launch support window' },
];

export default function Process() {
  return (
    <section id="process" className="relative py-24 md:py-40 bg-obsidian text-bone" data-testid="process-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="mb-16 md:mb-24">
          <span className="font-sans text-xs uppercase tracking-[0.3em] text-bone/40">How we work</span>
          <h2 className="serif tracking-tighter text-[11vw] md:text-[6vw] leading-none mt-4">
            Four steps, <span className="italic">zero</span> guesswork
          </h2>
        </div>

        <div className="grid md:grid-cols-4 gap-10 md:gap-6">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="border-t border-bone/15 pt-6"
              data-testid={`process-step-${i}`}
            >
              <div className="serif text-signal text-6xl md:text-7xl leading-none mb-6">{s.n}</div>
              <h3 className="serif text-3xl tracking-tight mb-4">{s.title}</h3>
              <p className="font-sans text-sm text-bone/60 leading-relaxed mb-6">{s.desc}</p>
              <div className="font-sans text-[11px] uppercase tracking-[0.15em] text-bone/40 border border-bone/15 rounded-full px-3 py-2 inline-block">
                {s.cadence}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
